import React from 'react'

class ChatBox extends React.Component {
    render() {
        return <div id='tawk_5fb91f60a1d54c18d8ebf41a'></div>
    }
}
export default ChatBox